import { Fragment, useState, useEffect } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const genres = [
  { value: "All", order: "desc" },
  { value: "Action", order: "desc" },
  { value: "Ads", order: "desc" },
  { value: "Adventure", order: "desc" },
  { value: "Animals", order: "desc" },
  { value: "Anime", order: "desc" },
  { value: "Art", order: "desc" },
  { value: "Christmas", order: "desc" },
  { value: "Comedy", order: "asc" },
  { value: "Conflict", order: "desc" },
  { value: "Crime", order: "desc" },
  { value: "Culture", order: "desc" },
  { value: "Dark", order: "desc" },
  { value: "Deep", order: "desc" },
  { value: "Documentary", order: "desc" },
  { value: "Drama", order: "desc" },
  { value: "Dystopian", order: "desc" },
  { value: "Emotional", order: "desc" },
  { value: "Family", order: "desc" },
  { value: "Fantasy", order: "desc" },
  { value: "Fashion", order: "desc" },
  { value: "Halloween", order: "desc" },
  { value: "History", order: "desc" },
  { value: "Holiday", order: "desc" },
  { value: "Horror", order: "desc" },
  { value: "Intellectual", order: "desc" },
  { value: "Mystery", order: "desc" },
  { value: "Music", order: "desc" },
  { value: "Parody", order: "desc" },
  { value: "Poetic", order: "desc" },
  { value: "Promotion", order: "desc" },
  { value: "Religion", order: "desc" },
  { value: "Romance", order: "desc" },
  { value: "Sad", order: "desc" },
  { value: "Sci-fi", order: "desc" },
  { value: "Space", order: "desc" },
  { value: "Strange", order: "desc" },
  { value: "Super Heroes", order: "desc" },
  { value: "Supportive", order: "desc" },
  { value: "Thriller", order: "desc" },
  { value: "War", order: "desc" },
  { value: "Western", order: "desc" },
  { value: "Other", order: "desc" },
];

export default function SelectGenre({ setCurrentGenre }) {
  const [selected, setSelected] = useState(genres[0]);

  useEffect(() => {
    setCurrentGenre(selected);
  }, [selected]);

  return (
    <div className="w-40">
      <Listbox value={selected} onChange={setSelected}>
        <div className="relative mt-1">
          <Listbox.Button className="pl-3 pr-10 cursor-pointer text-md font-medium me-2 px-3 py-1.5 mt-2 text-opacity-30   border border-white border-opacity-40 relative w-full text-left focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2  rounded-lg  bg-lightGray grow text-white">
            <span className="block  text-white">{selected.value}</span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <FontAwesomeIcon icon={faChevronDown} />
            </span>
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute mt-4 max-h-60 w-full overflow-auto rounded-md bg-lightGray py-3 shadow-lg ring-1 ring-black/5 focus:outline-none p-3 border border-white border-opacity-40 ">
              {genres.map((genre, i) => (
                <Listbox.Option
                  key={i}
                  className={({ active }) =>
                    `relative select-none py-2 pl-2 pr-4 cursor-pointer text-white hover:bg-primary hover:text-black rounded-lg${
                      active ? "" : ""
                    }`
                  }
                  value={genre}
                >
                  {({ selected }) => (
                    <>
                      <span
                        className={`block truncate ${
                          selected ? "font-medium" : "font-normal"
                        }`}
                      >
                        {genre.value}
                      </span>
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
}
